/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { UpdateRecourseCriteriaRestRequest } from '../../models/update-recourse-criteria-rest-request';
import { UpdateRecourseCriteriaRestResponse } from '../../models/update-recourse-criteria-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface UpdateRecourseCriteria$Params {
  id: number;
  body: UpdateRecourseCriteriaRestRequest;
}

export function updateRecourseCriteria(
  http: HttpClient,
  rootUrl: string,
  params: UpdateRecourseCriteria$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UpdateRecourseCriteriaRestResponse>> {
  const rb = new RequestBuilder(rootUrl, updateRecourseCriteria.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateRecourseCriteriaRestResponse>;
    }),
  );
}

updateRecourseCriteria.PATH = '/recourse-criteria/{id}';
